import React, { useState } from 'react';
import { Button } from './ui/Button';
import { Input } from './ui/Input';
import { X, CheckCircle } from 'lucide-react';
interface DeliveryConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: (signature: string, comments: string) => Promise<void>;
  clientName: string;
}
export function DeliveryConfirmationModal({
  isOpen,
  onClose,
  onConfirm,
  clientName
}: DeliveryConfirmationModalProps) {
  const [signature, setSignature] = useState('');
  const [comments, setComments] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  if (!isOpen) return null;
  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    try {
      await onConfirm(signature, comments);
      onClose();
    } catch (error) {
      console.error('Delivery confirmation failed', error);
    } finally {
      setIsSubmitting(false);
    }
  };
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 p-4" data-id="element-65">
      <div className="bg-white rounded-xl shadow-xl w-full max-w-md overflow-hidden animate-in fade-in zoom-in-95 duration-200" data-id="element-66">
        <div className="flex justify-between items-center p-4 border-b border-gray-100" data-id="element-67">
          <h3 className="text-lg font-bold text-gray-900" data-id="element-68">
            Confirmer la Livraison
          </h3>
          <button onClick={onClose} className="text-gray-400 hover:text-gray-500" data-id="element-69">
            <X className="w-5 h-5" data-id="element-70" />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-4" data-id="element-71">
          <div className="bg-blue-50 p-3 rounded-lg text-sm text-blue-800 mb-4" data-id="element-72">
            Client: <span className="font-bold" data-id="element-73">{clientName}</span>
          </div>

          <div data-id="element-74">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-75">
              Signature / Nom du réceptionnaire
            </label>
            <Input value={signature} onChange={e => setSignature(e.target.value)} placeholder="ex: Reçu par Mme Ben Ali" required data-id="element-76" />
          </div>

          <div data-id="element-77">
            <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-78">
              Commentaires (Optionnel)
            </label>
            <textarea value={comments} onChange={e => setComments(e.target.value)} rows={3} className="w-full rounded-lg border border-gray-300 px-3 py-2 text-sm outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500" placeholder="ex: Livré au gardien..." data-id="element-79" />
          </div>

          <div className="flex gap-3 pt-2" data-id="element-80">
            <Button type="button" variant="secondary" onClick={onClose} fullWidth data-id="element-81">
              Annuler
            </Button>
            <Button type="submit" fullWidth isLoading={isSubmitting} leftIcon={<CheckCircle className="w-4 h-4" data-id="element-83" />} data-id="element-82">
              Confirmer
            </Button>
          </div>
        </form>
      </div>
    </div>;
}